import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload } from 'antd'
import { useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { useVestingContext } from 'context/vesting-context-provider'
import { logError, logInfo } from 'utils/logger'

const ButtonUpload = ({
  disable,
  onAfterUpload,
}: {
  disable?: boolean
  onAfterUpload: () => void
}) => {
  const { type } = useVestingContext()

  const [file, setFile] = useState([])

  const [isUploading, setIsUploading] = useState(false)

  const handleUpload = async (info: any) => {
    setIsUploading(true)
    const { file } = info
    const formData = new FormData()
    formData.append('file', file)
    if (type) {
      formData.append('type', type.toString())
    }

    try {
      const response = await AppAdmin.uploadWhitelistVesting(formData)
      logInfo('on after upload----------------', response)
      if (response.data.success) {
        message.success('File uploaded successfully')
        setFile(response.data.data.filePath)
        onAfterUpload()
      }
    } catch (error: any) {
      message.error(error?.message || 'File upload failed')
      logError('Upload error:', error)
    }
    setIsUploading(false)
  }

  return (
    <Upload
      disabled={isUploading || disable}
      fileList={file}
      customRequest={handleUpload}
      showUploadList={false}
    >
      <Button
        size="large"
        type="primary"
        icon={<UploadOutlined />}
        disabled={isUploading || disable}
      >
        {isUploading ? 'Uploading...' : 'Upload Whitelist CSV file'}
      </Button>
    </Upload>
  )
}

export default ButtonUpload
